/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/

/** Import ENVIRONMENTAL VARIABLES */
import ENV from "react-dotenv";

import React, {useContext, useEffect, useState} from "react";

import {useDispatch} from "react-redux";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import ApplicationApiContext from "@Contexts/Api";

import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import DISPOSITION_INTERFACE from "@Services/Application/Interfaces/Dispositions/Disposition";
import PRODUCT_INTERFACE from "@Services/Application/Interfaces/Products/Product";
import VEHICLE_INTERFACE from "@Services/Application/Interfaces/Vehicles/Vehicle";

import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";

import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";


import dateFormat from "dateformat";


import {Helmet} from "react-helmet";


import {NavLink} from "react-router-dom";


import {Button, Col, Form, Row} from "react-bootstrap";

import {AiOutlineCheck} from "react-icons/all";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";
import WarningMessageComponent from "@Components/UI/Communicates/Messages/Warning";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";
import MainContentLoaderComponent from "@Components/UI/Loaders/MainContent";
import BlockContentPictureComponent from "@Components/UI/Containers/Block/Picture";


import monitoryNoteIcon from "@Icons/Menu/monitory_notes.png";
import REST_API_REQUEST from "@Services/Utilities/Requests";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import CHANGE_API_REQUEST_TOKEN_ACTION from "@Actions/Api/ChangeApiRequestTokenValue";
import prepareRestApiRequestToken from "@Services/Utilities/RequestToken/Prepare";
import ContentInformationComponent from "@Components/UI/Content/Information";


type DispositionsStationsListPageProps = {
    match?: any; location?: any;
};


export const TerminalDispositionsListPageComponent: React.FC<DispositionsStationsListPageProps> = ({
    match, location
}): JSX.Element | null => {


    const TERMINAL_ID = match?.params?.terminalId;
    const TERMINAL_NAME = location?.state?.terminalName;
    const selectedDispositions: DISPOSITION_INTERFACE[] | undefined = location?.state?.selectedDispositions;


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);


    const [VEHICLES_LIST, SET_VEHICLES_LIST] = useState<VEHICLE_INTERFACE[] | null>(null);
    const [VEHICLES_LIST_ERROR, SET_VEHICLES_LIST_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    useEffect(() => {

        if (!LOGGED_USER?.userID || !REST_API_URL) return;

        if (VEHICLES_LIST) return;

        const VEHICLES_LIST_API_URL = REST_API_URL + "/Vehicle/List";

        const VEHICLES_LIST_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID, Mode: "A", Favourite: false
        };

        const GET_VEHICLES_LIST = async () => {

            try {

                const VEHICLES_RESPONSE = await REST_API_REQUEST(
                    VEHICLES_LIST_API_URL,
                    VEHICLES_LIST_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (VEHICLES_RESPONSE.status === 200) {
                    const CONTENT: string = await VEHICLES_RESPONSE.text();
                    SET_VEHICLES_LIST(CONTENT.trim() ? JSON.parse(CONTENT)?.Vehicles : []);
                } else {
                    const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await VEHICLES_RESPONSE.json();
                    SET_VEHICLES_LIST_ERROR({ErrorCode: VEHICLES_RESPONSE.status, UserMessage: CONTENT.UserMessage});
                }

            } catch (e) {
                SET_VEHICLES_LIST_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

        };

        GET_VEHICLES_LIST();

    }, [TERMINAL_ID]);


    const [SELECTED_FRONT_VEHICLE, SET_SELECTED_FRONT_VEHICLE] = useState<string>("");
    const [SELECTED_REAR_VEHICLE, SET_SELECTED_REAR_VEHICLE] = useState<string>("");

    const CHANGE_SELECTED_FRONT_VEHICLE = (vehicleRegNr: string) => {
        SET_SELECTED_FRONT_VEHICLE(vehicleRegNr);
        if (AVAILABLE_VEHICLES[vehicleRegNr]?.IsTank) SET_SELECTED_REAR_VEHICLE("-1");
        SET_SELECTED_DISPOSITIONS([]);
    };

    const CHANGE_SELECTED_REAR_VEHICLE = (vehicleRegNr: string) => {
        SET_SELECTED_REAR_VEHICLE(vehicleRegNr);
        SET_SELECTED_DISPOSITIONS([]);
    };


    const [DISPOSITIONS_LIST, SET_DISPOSITIONS_LIST] = useState<[] | null>(null);
    const [DISPOSITIONS_LIST_ERROR, SET_DISPOSITIONS_LIST_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);


    useEffect(() => {

        if (!TERMINAL_ID || !VEHICLES_LIST) return;

        if (!SELECTED_FRONT_VEHICLE || !SELECTED_REAR_VEHICLE) return;

        const DISPOSITIONS_LIST_API_URL = REST_API_URL + "/Disp/List";

        const DISPOSITIONS_LIST_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID,
            TerminalNo: TERMINAL_ID,
            FrontVehicleRegNo: SELECTED_FRONT_VEHICLE !== "-1" ? SELECTED_FRONT_VEHICLE : null,
            RearVehicleRegNo: SELECTED_REAR_VEHICLE !== "-1" ? SELECTED_REAR_VEHICLE : null
        };

        const GET_STATIONS_DISPOSITIONS_LIST = async () => {

            try {

                const DISPOSITIONS_RESPONSE = await REST_API_REQUEST(
                    DISPOSITIONS_LIST_API_URL,
                    DISPOSITIONS_LIST_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (DISPOSITIONS_RESPONSE.status === 200) {
                    const CONTENT: string = await DISPOSITIONS_RESPONSE.text();
                    SET_DISPOSITIONS_LIST(CONTENT.trim() ? JSON.parse(CONTENT)?.Disps : []);
                } else {
                    const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await DISPOSITIONS_RESPONSE.json();
                    SET_VEHICLES_LIST_ERROR({ErrorCode: DISPOSITIONS_RESPONSE.status, UserMessage: CONTENT.UserMessage});
                }

            } catch (e) {
                SET_DISPOSITIONS_LIST_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

        };

        GET_STATIONS_DISPOSITIONS_LIST();

    }, [SELECTED_FRONT_VEHICLE, SELECTED_REAR_VEHICLE]);


    const [SELECTED_DISPOSITIONS, SET_SELECTED_DISPOSITIONS] = useState<string[]>([]);

    const selectedDispositionsListHandler = (dispositionId: string) => {
        let updatedSelectedDispositionsList = [];
        if (SELECTED_DISPOSITIONS.includes(dispositionId)) {
            updatedSelectedDispositionsList = SELECTED_DISPOSITIONS.filter(item => item !== dispositionId)
        } else {
            updatedSelectedDispositionsList = [...SELECTED_DISPOSITIONS, dispositionId];
        }
        SET_SELECTED_DISPOSITIONS(updatedSelectedDispositionsList);
    };

    useEffect(() => {
        if (!selectedDispositions || !selectedDispositions.length) return;
        const selectedDispositionsList = selectedDispositions ? selectedDispositions.map((disp) => disp.DispNo) : [];
        SET_SELECTED_DISPOSITIONS(selectedDispositionsList);
    }, [selectedDispositions]);


    useEffect(() => {
        return () => {
            SET_VEHICLES_LIST(null);
            SET_DISPOSITIONS_LIST(null);
            SET_SELECTED_FRONT_VEHICLE("");
            SET_SELECTED_REAR_VEHICLE("");
        };
    }, []);


    VEHICLES_LIST?.sort(
        (vehicle1, vehicle2) => vehicle1.Favorite && !vehicle2.Favorite ? -1 : 1
    );

    const ACTIVE_FRONT_VEHICLE = VEHICLES_LIST?.filter(
        (VEHICLE) => !!VEHICLE.Active && !!VEHICLE.IsFront
    )[0];

    const ACTIVE_REAR_VEHICLE = VEHICLES_LIST?.filter(
        (VEHICLE) => !!VEHICLE.Active && !VEHICLE.IsFront
    )[0];

    useEffect(() => {
        if (!VEHICLES_LIST) return;
        SET_SELECTED_FRONT_VEHICLE(ACTIVE_FRONT_VEHICLE?.RegNo || "-1");
        SET_SELECTED_REAR_VEHICLE(ACTIVE_REAR_VEHICLE?.RegNo || "-1");
    }, [VEHICLES_LIST]);

    // useEffect(() => {
    //     if (!ACTIVE_FRONT_VEHICLE) return;
    //     SET_SELECTED_FRONT_VEHICLE(ACTIVE_REAR_VEHICLE?.RegNo || "-1");
    // }, [ACTIVE_FRONT_VEHICLE]);
    //
    // useEffect(() => {
    //     if (!ACTIVE_REAR_VEHICLE) return;
    //     SET_SELECTED_REAR_VEHICLE(ACTIVE_REAR_VEHICLE?.RegNo || "-1");
    // }, [ACTIVE_REAR_VEHICLE]);

    if (!LOGGED_USER || !LOGGED_USER?.userID) return null;


    if (VEHICLES_LIST_ERROR) return <ErrorMessageComponent messageText={VEHICLES_LIST_ERROR.UserMessage} />;


    if (DISPOSITIONS_LIST_ERROR) return <ErrorMessageComponent messageText={DISPOSITIONS_LIST_ERROR.UserMessage} />;


    if (!DISPOSITIONS_LIST || !VEHICLES_LIST) return <MainContentLoaderComponent />;


    if (VEHICLES_LIST?.length === 0) return <ContentInformationComponent contentMessage={`Brak dostępnych pojazdów`} />


    const AVAILABLE_VEHICLES = Object.fromEntries(
        VEHICLES_LIST.map((vehicle: VEHICLE_INTERFACE) => [vehicle.RegNo, vehicle])
    );


    const SELECTED_FRONT_VEHICLE_IS_TANK = !!AVAILABLE_VEHICLES[SELECTED_FRONT_VEHICLE]?.IsTank;


    const DispositionList = DISPOSITIONS_LIST.map((disposition: DISPOSITION_INTERFACE) => {

        const productsOwnersNames = new Set();
        const productsReceiversNames = new Set();
        const productsSENTValues = new Set();

        disposition?.DispItems?.forEach((product: PRODUCT_INTERFACE) => {
            if (product.ClientName) productsOwnersNames.add(product.ClientName);
            if (product.ReceiverName) productsReceiversNames.add(product.ReceiverName);
            productsSENTValues.add(product.SENTNumber);
        });


        const DISPOSITION_SELECTED_STATUS = SELECTED_DISPOSITIONS.includes(disposition.DispNo);
        const DISPOSITION_IS_VALID_STATUS = (new Date(disposition.ValidTo || "")).getTime() > (new Date()).getTime();

        const dispositionSentNumbers = Array.from(productsSENTValues).map((sent: any, i: number) =>
            <span key={i}>{sent}</span>
        );

        return (
            <Col key={disposition.DispNo} xs={12} className={`terminal-disposition-element` + (DISPOSITION_SELECTED_STATUS ? " selected" : "") + (disposition.IsBooked ? " booked" : "") + (!DISPOSITION_IS_VALID_STATUS ? " disabled" : "")}>

                <Row className={"terminal-disposition-element-content"}>

                    <Col as={NavLink} to={`/dyspozycje/${disposition.TerminalMasterNo}/${disposition.DispNo.replaceAll("/", "--")}`} xs={9} className={"terminal-disposition-data"}>

                        <Row className={"terminal-disposition-header-container"}>

                            <Col xs={12} className={"terminal-disposition-header"}>
                                <span className={"disposition-id"}>{disposition?.DispNo}</span>
                            </Col>

                            {!!disposition.ValidFrom && !!disposition.ValidTo &&
	                        <Col xs={12} className={"terminal-disposition-valid-period"}>
		                        <span className={"information-label"}>{`od`}</span>
		                        <span className={"information-value"}>{dateFormat(new Date(disposition.ValidFrom), "dd-mm-yyyy")}</span>
		                        <span className={"information-label"}>{`do`}</span>
		                        <span className={"information-value"}>{dateFormat(new Date(disposition.ValidTo), "dd-mm-yyyy")}</span>
	                        </Col>
                            }

                            {dispositionSentNumbers.length > 0 &&
	                        <Col xs={12} className={"terminal-disposition-sent-numbers terminal-disposition-information"}>
                                {dispositionSentNumbers}
	                        </Col>
                            }

                            <Col xs={12} className={"terminal-disposition-information"}>
                                <span className={"disposition-information-label"}>{`Zleceniodawca:`}</span>
                                <span className={"disposition-information-value"}>{Array.from(productsOwnersNames).join(", ")}</span>
                            </Col>

                            {productsReceiversNames.size > 0 &&
	                        <Col xs={12} className={"terminal-disposition-information"}>
		                        <span className={"disposition-information-label"}>{`Odbiorca:`}</span>
		                        <span className={"disposition-information-value"}>{Array.from(productsReceiversNames).join(", ")}</span>
	                        </Col>
                            }

                        </Row>

                    </Col>

                    <Col xs={3} className={"terminal-disposition-actions"}>

                        <Row className={"terminal-disposition-actions-container"}>

                            {!disposition.IsBooked && ((!!SELECTED_FRONT_VEHICLE && SELECTED_FRONT_VEHICLE !== "-1" && !!SELECTED_REAR_VEHICLE && SELECTED_REAR_VEHICLE !== "-1") || SELECTED_FRONT_VEHICLE_IS_TANK === true) &&
	                        <Col xs={12} className={"terminal-disposition-select-handler terminal-disposition-action"}>
                                <span onClick={() => selectedDispositionsListHandler(disposition.DispNo)} className={DISPOSITION_SELECTED_STATUS ? "checked" : ""}>
                                    {DISPOSITION_SELECTED_STATUS && <AiOutlineCheck />}
                                </span>
	                        </Col>
                            }

                            {!!disposition.IsBooked &&
	                        <Col xs={12} className={"terminal-disposition-booked-status terminal-disposition-action"}>
		                        <img src={monitoryNoteIcon} />
		                        <span>{`Zaawizowana`}</span>
	                        </Col>
                            }

                        </Row>

                    </Col>


                </Row>

            </Col>
        );

    });


    const AVAILABLE_FRONT_VEHICLES = Object.fromEntries(
        Object.entries(AVAILABLE_VEHICLES).filter(([vehicleRegNo, vehicle]: [string, VEHICLE_INTERFACE]) => !!vehicleRegNo && !!vehicle.IsFront)
    );

    const AVAILABLE_REAR_VEHICLES = Object.fromEntries(
        Object.entries(AVAILABLE_VEHICLES).filter((
            [vehicleRegNo, vehicle]: [string, VEHICLE_INTERFACE]
        ) => {
            if (!SELECTED_FRONT_VEHICLE) return !!vehicleRegNo && !vehicle.IsFront;
            const FRONT_VEHICLE: VEHICLE_INTERFACE = AVAILABLE_VEHICLES[SELECTED_FRONT_VEHICLE];
            if (!FRONT_VEHICLE?.Type) return;
            if (FRONT_VEHICLE?.Type === "C") return !!vehicleRegNo && !vehicle.IsFront && vehicle.Type === "N";
            if (FRONT_VEHICLE?.Type === "A") return !!vehicleRegNo && !vehicle.IsFront && vehicle.Type === "P";
        })
    );


    const USABLE_DISPOSITIONS: number = DISPOSITIONS_LIST.filter(
        (disposition: DISPOSITION_INTERFACE) => !disposition.IsBooked
    ).length;


    interface CREATE_MONITORY_NOTE_DATA_INTERFACE {
        DISPOSITIONS?: string[];
        TERMINAL?: {TERMINAL_NAME: string; TERMINAL_ID: string}
        VEHICLES?: {FRONT: VEHICLE_INTERFACE; REAR: VEHICLE_INTERFACE};
    }

    const CREATE_MONITORY_NOTE_DATA: CREATE_MONITORY_NOTE_DATA_INTERFACE = {
        DISPOSITIONS: SELECTED_DISPOSITIONS,
        TERMINAL: {TERMINAL_NAME, TERMINAL_ID},
        VEHICLES: {
            FRONT: AVAILABLE_VEHICLES[SELECTED_FRONT_VEHICLE] || null,
            REAR: AVAILABLE_VEHICLES[SELECTED_REAR_VEHICLE] || null
        }
    };


    const FRONT_VEHICLE = AVAILABLE_FRONT_VEHICLES[SELECTED_FRONT_VEHICLE] || null;
    const REAR_VEHICLE = AVAILABLE_REAR_VEHICLES[SELECTED_REAR_VEHICLE] || null;


    return (
        <BlockContentContainerComponent cssClasses={"station-dispositions-page-component"}>

            {/* Helmet Module Component - Set Document Title */}
            <Helmet>
                <title>{`${ENV.APP_TITLE} - Dyspozycje dla ${TERMINAL_NAME}`}</title>
            </Helmet>
            {/* /Helmet Module Component - Set Document Title */}

            <BlockContentHeaderComponent headerText={`Moje Dyspozycje`} />

            <Col xs={12} className={"dispositions-header"}>
                <span>{`Baza Paliw ${TERMINAL_NAME}`}</span>
            </Col>

            <>
            {(USABLE_DISPOSITIONS > 0 || SELECTED_FRONT_VEHICLE || SELECTED_REAR_VEHICLE) &&
            <Col xs={12} className={"dispositions-vehicle-choice"}>
                <Row className={"dispositions-vehicle-choice-content"}>
                    <Col xs={6} className={"dispositions-vehicles-list dispositions-front-vehicles"}>
                        <h5 className={"dispositions-vehicles-label"}><span>{`Pojazd przedni`}</span></h5>
                        {Object.entries(AVAILABLE_FRONT_VEHICLES).length > 0 ?
                        <Form.Control as={"select"} value={SELECTED_FRONT_VEHICLE} onChange={(e) => CHANGE_SELECTED_FRONT_VEHICLE(e.target.value)}>
                            <option value={"-1"}>- wybierz -</option>
                            {Object.entries(AVAILABLE_FRONT_VEHICLES).map(([vehicleRegNo, vehicle]: [string, VEHICLE_INTERFACE]) => <option key={vehicleRegNo} value={vehicleRegNo}>{vehicleRegNo} ({vehicle.TypeName})</option>)}
                        </Form.Control>
                        :
                        <ContentInformationComponent contentMessage={"Brak pojazdów"} />
                    }
                    </Col>
                    <Col xs={6} className={"dispositions-vehicles-list dispositions-rear-vehicles"}>
                        <h5 className={"dispositions-vehicles-label"}><span>{`Pojazd tylny`}</span></h5>
	                    <Form.Control as={"select"} value={SELECTED_REAR_VEHICLE} disabled={ !(Object.entries(AVAILABLE_REAR_VEHICLES).length > 0)} onChange={(e) => CHANGE_SELECTED_REAR_VEHICLE(e.target.value)}>
                            <option value={"-1"}>{Object.entries(AVAILABLE_REAR_VEHICLES).length > 0 ? `-wybierz -` : `brak pojazdów`}</option>
                            {Object.entries(AVAILABLE_REAR_VEHICLES).map(([vehicleRegNo, vehicle]: [string, VEHICLE_INTERFACE]) => <option key={vehicleRegNo} value={vehicleRegNo}>{vehicleRegNo} ({vehicle.TypeName})</option>)}
	                    </Form.Control>
                    </Col>
                </Row>
            </Col>
            }
            </>

            {USABLE_DISPOSITIONS > 0 && !(!!FRONT_VEHICLE && FRONT_VEHICLE?.IsTank || !!FRONT_VEHICLE && !!REAR_VEHICLE) &&
            <Col xs={12} className={"no-list-elements-message default-system-message"} style={{marginBottom: 20}}>
	            <span>{`Jeżeli chcesz utworzyć nową Awizację wybierz najpierw zestaw pojazdów`}</span>
            </Col>
            }

            <Col xs={12} className={"terminal-dispositions-list"}>
                <Row className={"terminal-dispositions-list-content"}>
                    {DispositionList?.length > 0 ?
                        DispositionList
                        :
                        <ContentInformationComponent contentMessage={`Brak dostępnych dyspozycji`} />
                    }
                </Row>
            </Col>

            <>
            {SELECTED_DISPOSITIONS.length > 0 &&
            <Col xs={12} className={"create-dispositions-monitory-note"}>
                <Button as={NavLink} to={{
                    pathname: ROUTER.AUTHENTICATED.MONITORY_NOTES.MONITORY_NOTE_CREATE.URL,
                    state: CREATE_MONITORY_NOTE_DATA
                }} variant={"primary"}>
                    <span>{`Utwórz nową awizację`}</span>
                </Button>
            </Col>
            }
            </>

        </BlockContentContainerComponent>
    )

};


export default TerminalDispositionsListPageComponent;
